import React from 'react'

function Documents() {
  return (
    <div>Documents are'nt ready to get published! </div>
  )
}

export default Documents